import {Button, Card, CardContent, CardHeader, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import Results from './Results';
import {AdjustmentType, GroupMember, GroupMemberAdjustment} from '../../../graphql/groups.datatypes';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import getGroupMember from '../getGroupMember.api';
import {useSnackbar} from 'notistack';
import GroupMemberAdjustmentModal from '../GroupMemberAdjustmentModal';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    linkButton: {
        marginRight: theme.spacing(1),
    },
}));

export const getBlankAdjustment = (groupMember: GroupMember): GroupMemberAdjustment => {
    return {
        __typename: 'GroupMemberAdjustment',
        id: -1,
        group_member_id: groupMember.id,
        amount: 0,
        adjustment_type: AdjustmentType.DISCOUNT,
        description: '',
    };
};

export const GroupMemberAdjustmentsListContent = (props: { groupMember: GroupMember, canEdit: boolean, isAdmin: boolean, }) => {
    const classes = useStyles();
    const {groupMember, canEdit, isAdmin} = props;
    const [selectedAdjustment, setSelectedAdjustment] = useState<GroupMemberAdjustment | null>(null);

    return (
        <Card className={classes.container}>
            <CardHeader title="Billing Party Payments" action={
                isAdmin && (<Button key={1} variant="contained" className={classes.linkButton}
                        onClick={() => setSelectedAdjustment(getBlankAdjustment(groupMember))}>Add Adjustment</Button>)
            }/>
            <CardContent>

                {groupMember.adjustments && (
                    <Results
                        className={classes.results}
                        adjustments={groupMember.adjustments}
                        setSelectedAdjustment={setSelectedAdjustment}
                    />
                )}

                {selectedAdjustment && (
                    <GroupMemberAdjustmentModal onClose={() => setSelectedAdjustment(null)} groupMember={groupMember}
                                                open={true} adjustment={selectedAdjustment}
                                                setSelectedAdjustment={setSelectedAdjustment}
                                                isAdmin={isAdmin}/>
                )}
            </CardContent>
        </Card>
    );
};

const GroupMemberAdjustmentsList = () => {
    const {history, match}: RouteComponentProps<{ id: string }> = useReactRouter();
    const classes = useStyles();
    const {id} = match.params;
    const groupMemberData = getGroupMember(Number(id));
    const {enqueueSnackbar} = useSnackbar();
    const title = 'Group Member Adjustments';

    useEffect(() => {
        if (groupMemberData.error) {
            enqueueSnackbar(`There was an error loading Group Member ${id}`, {variant: 'error'});
            history.push('/groupmembers');
        }
    }, [groupMemberData.error]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="groups" title={title}/>
            <LoadingOverlay loading={groupMemberData.loading}>
                {groupMemberData.data && groupMemberData.data.groupMember && (
                    <GroupMemberAdjustmentsListContent groupMember={groupMemberData.data.groupMember} isAdmin={true}
                                                       canEdit={true}/>
                )}
            </LoadingOverlay>
        </Page>
    );
};

export default GroupMemberAdjustmentsList;
